import { Section, Chapter, Reveal } from "./Section";
import { scrollTo } from "./Navbar";
import LeadForm from "./LeadForm";

const FOOTER_LINKS = [
  ["Ways to Give", "#give"],
  ["Prophetic Ministry", "#ministry"],
  ["Kingdom Associates", "#associates"],
  ["Spiritual Warfare", "#warfare"],
  ["Holistic Wellness", "#wellness"],
  ["Coaching", "#coaching"],
  ["Books & Resources", "#books"],
];

export default function Contact() {
  const go = (e, href) => { e.preventDefault(); scrollTo(href); };
  return (
    <>
      <Section id="contact" testid="contact-section">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-6">
            <Chapter number="10" label="Stay Connected" testid="contact-chapter"
              title={<>There&rsquo;s More <span className="text-vg">Ahead.</span></>}
              sub="The next chapter of Prophet Terrell Turner Ministries is about expansion, connection, development, and impact." />
            <Reveal delay={0.2} className="mt-8">
              <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal max-w-lg">
                Stay connected for upcoming ministry engagements, Spiritual Warfare Classes, The Kingdom Associates
                2026 relaunch, Holistic Wellness Ministry, books, coaching opportunities, teachings, and special events.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-6 glow-frame">
            <div className="rounded-[1.7rem] bg-[#0B0E16] p-7 sm:p-9">
              <p className="mb-6 font-mono text-sm font-semibold uppercase tracking-[0.25em] text-vg">Connect With Us</p>
              <LeadForm type="contact" idPrefix="contact" extra={["message"]} submitLabel="Stay Connected" />
            </div>
          </Reveal>
        </div>
      </Section>

      <footer data-testid="footer" className="relative z-10 border-t border-white/5 bg-black/40">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
          <div className="flex flex-col items-center text-center">
            <div className="relative group">
              <div aria-hidden className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-violet-600/30 to-amber-500/25 blur-xl opacity-60 group-hover:opacity-100 transition-opacity duration-500" />
              <img src="/assets/logo.jpeg" alt="Terrell Turner Ministries" data-testid="footer-logo"
                className="relative h-24 w-24 rounded-2xl object-cover ring-1 ring-white/15 transition-transform duration-500 group-hover:scale-105" />
            </div>
            <p className="mt-6 font-display text-2xl font-bold text-white">Prophet Terrell Turner Ministries</p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-vg">
              Equipping People &bull; Strengthening Leaders &bull; Advancing the Kingdom
            </p>            <nav className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3">
              {FOOTER_LINKS.map(([label, href]) => (
                <a key={href} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} href={href} onClick={(e) => go(e, href)}
                  className="text-sm font-medium font-mono uppercase tracking-[0.16em] text-slate-400 hover:text-white transition-colors duration-300">
                  {label}
                </a>
              ))}
            </nav>
            <p className="mt-10 text-sm text-slate-500">&copy; {new Date().getFullYear()} Prophet Terrell Turner Ministries. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
}
